import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { Toolbar } from "primereact/toolbar";
import { InputNumber } from "primereact/inputnumber";
import ordemService from "../services/ordemService";
import equipeService from "../services/equipeService";
import { Accordion, AccordionTab } from "primereact/accordion";
import { hasAnyAuthority, hasAuthority, hideProcessing, showProcessing } from "../utils/utils";
import Agenda from "./Agenda";
import agendaService from "../services/agendaService";
import { MegaMenu } from "primereact/megamenu";
import { Checkbox } from "primereact/checkbox";


var pendenteSalvar = false;

let _ordensInitialized = false;

export default function OrdemServicos() {
    const { id } = useParams(); // Recupera o parâmetro 'id' da URL
    const toast = useRef(null);
    const [ordem, setOrdem] = useState(null);
    const [displayDialogContaAzul, setDisplayDialogContaAzul] = useState(false);
    const [displayDeleteDialog, setDisplayDeleteDialog] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [numeroVendaContaAzul, setNumeroVendaContaAzul] = useState("");
    const [displayAnexarDocumentoDialog, setDisplayAnexarDocumentoDialog] = useState(false);
    const [displayDialogAgendaEquipe, setDisplayDialogAgendaEquipe] = useState(false);
    const [agendamentos, setAgendamentos] = useState([]);
    const [agenda, setAgenda] = useState(null);
    const fileInputRef = useRef(null);
    const [fotovoltaico, setFotovoltaico] = useState(null);
    const [tipoVenda, setTipoVenda] = useState(null);
    const [equipes, setEquipes] = useState([]);
    const [tituloAnexo, setTituloAnexo] = useState("Novo Anexo");
    const [tiposDocumento, setTiposDocumento] = useState([]);
    const [solicitarDocumentoDialog, setSolicitarDocumentoDialog] = useState(false);
    const [solicitarDocumentoForm, setSolicitarDocumentoForm] = useState({
        observacao: ""
    });
    const [informarVenda, setInformarVenda] = useState(true);
    const [documento, setDocumento] = useState("");

    const [anexoForm, setAnexoForm] = useState({
        nomeArquivo: "",
        observacao: "",
        base64: null,
        arquivos: []
    });

    const [tipoTelhado, setTipoTelhado] = useState(null)

    const [posVenda, setPosVenda] = useState(null);

    const [formData, setFormData] = useState({
        titulo: "",
        descricao: "",
        cliente: "",
        responsavel: "",
        status: "pendente",
        prioridade: "média",
        dataInicio: null,
        dataFim: null,
        valor: null
    });

    const [selectedItem, setSelectedItem] = useState(null);

    const statusAgendaOptions = [
        { "AGENDADO": "Agendado" }
    ];

    const statusOrdemOptions = {
        "CANCELADA": {label: "Cancelada", index: -1},
        "EM CADASTRO": {label: "Em Cadastro", index: 0},
        "ANALISE FINANCEIRA": {label: "Análise Financeira", index: 1},
        "PAGAMENTO CONFIRMADO": {label: "Pagamento Confirmado", index: 2},
        "REVISÃO DE DOCUMENTOS": {label: "Revisão de Documentos", index: 2},
        "AGUARDANDO PAGAMENTO ART": {label: "Aguardando Pagamento ART", index: 1.5},
        "PARECER DE ACESSO": {label: "Parecer de Acesso", index: 2},
        "ORÇAMENTO": {label: "Orçamento", index: 3},
        "AGUARDANDO PAGAMENTO": {label: "Aguardando Pagamento", index: 4},
        "AGENDAMENTO": {label: "Agendamento", index: 5},
        "AGENDADO": {label: "Agendado", index: 6},
        "REABERTA": {label: "Reaberta", index: 6},
        "PÓS-VENDA": {label: "Pós-venda", index: 7},
        "FINALIZADA": {label: "Finalizada", index: 8},
    };


    const prioridadeOptions = [
        { label: "Baixa", value: "baixa" },
        { label: "Média", value: "média" },
        { label: "Alta", value: "alta" },
        { label: "Urgente", value: "urgente" }
    ];

    // Carregar dados ao montar o componente
    useEffect(() => {

        //Evitar carregar a ordem novamente se já foi inicializado
        if (!_ordensInitialized) {
            _ordensInitialized = true;
            return;
        }

        if (id) {
            carregarOrdem(id);
        }else{
            setOrdem({vendas: [], status: "EM CADASTRO", prioridade: "baixa", anexos: []});
        }

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };

    }, [id]);

    const handleBeforeUnload = (event) => {
        if (!pendenteSalvar) return;

        event.preventDefault();
        event.returnValue = ""; // necessário para alguns navegadores
    };

    const carregarOrdem = async (id) => {
        
        try {
            showProcessing();
            
            const response = await ordemService.get(id);

            if (response.status === 200) {
                setOrdem(response.data);
            }else{
                setOrdem(null);
            }
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao carregar ordens de serviço"
            });
        } finally {
            hideProcessing();
        }
    };
    

    const deleteOrdem = async () => {
        try {
            
            await ordemService.delete(ordem.id);
            
            toast.current.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Ordem de serviço deletada com sucesso"
            });
            
            window.location.href = "/ordens";

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao deletar ordem de serviço"
            });
        }
    };

    const getSeverity = (status) => {
        switch (status) {
            case "concluida":
                return "success";
            case "progresso":
                return "warning";
            case "pendente":
                return "info";
            case "cancelada":
                return "danger";
            default:
                return "info";
        }
    };

    const getPrioridadeSeverity = (prioridade) => {
        switch (prioridade) {
            case "urgente":
                return "danger";
            case "alta":
                return "warning";
            case "média":
                return "info";
            case "baixa":
                return "success";
            default:
                return "info";
        }
    };

    const dataBodyTemplate = (rowData, field) => {
        if (!rowData[field]) return "-";
        const data = new Date(rowData[field]);
        return data.toLocaleDateString("pt-BR");
    };

    const valorBodyTemplate = (rowData) => {
        if (!rowData.valor) return "-";
        return new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL"
        }).format(rowData.valor);
    };

    const deleteDialogFooter = () => (
        <div className="dialog-footer">
            <Button
                label="Não"
                icon="pi pi-times"
                className="p-button-text"
                onClick={() => setDisplayDeleteDialog(false)}
            />
            <Button
                label="Sim"
                icon="pi pi-check"
                className="p-button-danger"
                onClick={deleteOrdem}
            />
        </div>
    );

    const saveOrdem = async () => {
        try {
            showProcessing();
            
            const response = await ordemService.save(ordem);

            if (!id) {
                pendenteSalvar = false;
                window.location.href = `/ordem/${response.data.id}`;
            }else{
                setOrdem(response.data);
                pendenteSalvar = false;
            }

            toast.current.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Ordem de serviço atualizada com sucesso"
            });
            
        } catch (error) {

            if (error.response && error.response.data) {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: error.response.data
                });
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao salvar ordem de serviço"
                });
            }
        } finally {
            hideProcessing();
        }
    };

    const solicitarAgendamento = async () => {

        if (!window.confirm("Tem certeza que deseja enviar esta ordem de serviço para agendamento?")) {
            return;
        }

        try {

            showProcessing();

            await saveOrdem();

            const response = await ordemService.solicitarAgendamento(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Ordem de serviço enviada para agendamento com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao enviar ordem de serviço para agendamento"
                });
        } finally {
            hideProcessing();
        }
    };

    const solicitarAnaliseFinanceira = async () => {

        if (ordem.vendas.length === 0) {
            toast.current.show({
                severity: "warn",
                summary: "Aviso",
                detail: "Não é possível solicitar análise financeira sem vendas associadas"
            });
            return;
        }

        if (!window.confirm("Tem certeza que deseja solicitar análise financeira para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            await saveOrdem();

            const response = await ordemService.solicitarAnaliseFinanceira(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Solicitação de análise financeira realizada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao solicitar análise financeira"
                });
        } finally {
            hideProcessing();
        }
    }

    const confirmarPagamento = async () => {

        if (!window.confirm("Tem certeza que deseja confirmar o pagamento para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.confirmarPagamento(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Pagamento confirmado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao confirmar pagamento"
                });
        } finally {
            hideProcessing();
        }

    }

    const confirmarFinalizacaoParecerAcesso = async () => {

        if (!window.confirm("Tem certeza que deseja confirmar a finalização do parecer de acesso para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.confirmarFinalizacaoParecerAcesso(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Finalização do parecer de acesso confirmada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao confirmar finalização do parecer de acesso"
                });
        } finally {
            hideProcessing();
        }

    }

    const cancelarVendaFotovoltaica = async () => {
        if (!window.confirm("Tem certeza que deseja cancelar a venda fotovoltaica para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.cancelarVendaFotovoltaica(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Venda fotovoltaica cancelada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao cancelar venda fotovoltaica"
                });
        } finally {
            hideProcessing();
        }
    }

    const finalizarOrcamento = async () => {
        if (!window.confirm("Tem certeza que deseja finalizar o orçamento para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.finalizarOrcamento(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Orçamento finalizado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao finalizar orçamento"
                });
        } finally {
            hideProcessing();
        }

    }

    const finalizarOrcamentoSemPagamento = async () => {
        if (!window.confirm("Tem certeza que deseja finalizar o orçamento para esta ordem de serviço sem notificar o financeiro?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.finalizarOrcamentoSemPagamento(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Orçamento finalizado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao finalizar orçamento"
                });
        } finally {
            hideProcessing();
        }

    }

    const confirmarPagamentoFotovoltaico = async () => {

        if (!window.confirm("Tem certeza que deseja confirmar o pagamento para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.confirmarPagamentoFotovoltaico(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Pagamento fotovoltaico confirmado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao confirmar pagamento fotovoltaico"
                });
        } finally {
            hideProcessing();
        }
    }

    const finalizarOrdemServico = async () => {
        if (!window.confirm("Tem certeza que deseja finalizar esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.finalizarOrdemServico(ordem.id, posVenda || {});

            if (response.status === 200) {
                setOrdem(response.data);
                setPosVenda(null);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Ordem de serviço finalizada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao finalizar ordem de serviço"
                });
        } finally {
            hideProcessing();
        }
    }

    const reabrirOrdemServico = async () => {
        if (!window.confirm("Tem certeza que deseja reabrir esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.reabrirOrdemServico(ordem.id, posVenda);

            if (response.status === 200) {
                setOrdem(response.data);
                setPosVenda(null);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Ordem de serviço reaberta com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao reabrir ordem de serviço"
                });
        } finally {
            hideProcessing();
        }
    }

    const openVendaContaAzulDialog = () => {
        // Lógica para abrir o diálogo de importação da venda do Conta Azul
        // Por exemplo, você pode definir um estado para controlar a visibilidade do diálogo
        setNumeroVendaContaAzul(null);
        setFotovoltaico(null);
        setTipoVenda(null);
        setDisplayDialogContaAzul(true);
        setTipoTelhado(null);
    }

    const contaAzulDialogFooter = () => (
        <div>
            <Button
                label="Cancelar"
                icon="pi pi-times"
                className="button-cancel"
                onClick={() => setDisplayDialogContaAzul(false)}
            />
            <Button
                label="Confirmar"
                icon="pi pi-check"
                className="button-save"
                disabled={((ordem?.vendas?.filter(venda => venda.tipo === "FOTOVOLTAICA").length > 0 && tipoVenda && tipoVenda !== "FOTOVOLTAICA") ||
                      (ordem?.vendas?.filter(venda => venda.tipo !== "FOTOVOLTAICA").length > 0 && tipoVenda && tipoVenda === "FOTOVOLTAICA")) }
                onClick={importarVendaContaAzul}
            />
        </div>
    );

    const importarVendaContaAzul = async () => {
        try {

            if (fotovoltaico === null && informarVenda) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Selecione se é fotovoltaico"
                });
                return;
            }

            if (!tipoVenda && informarVenda) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Selecione o tipo de venda"
                });
                return;
            }

            if (tipoVenda === "FOTOVOLTAICA" && !ordem.tipoTelhado && !tipoTelhado){
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Selecione o tipo de telhado"
                });
                return;
            }

            if (informarVenda && ordem.vendas.some(venda => venda.numero === parseInt(numeroVendaContaAzul))) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "A venda do Conta Azul já foi importada para esta ordem de serviço"
                });
                return;
            }

            if (!informarVenda && !documento) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Informe o documento do cliente"
                });
                return;
            }

            if (informarVenda) {
                showProcessing();
                // Lógica para importar a venda do Conta Azul para a ordem de serviço
                // Por exemplo, você pode chamar uma função do serviço que realiza a importação
                const response = await ordemService.getVendaContaAzul(numeroVendaContaAzul);

                if (response.status === 200) {

                    var venda = response.data;

                    venda.fotovoltaico = fotovoltaico;
                    venda.tipo = tipoVenda;

                    if (!ordem.cliente) {
                        ordem.cliente = venda.cliente;
                        ordem.idVendedor = venda.idVendedor;
                        ordem.nomeVendedor = venda.nomeVendedor;
                    }else if (ordem.cliente.idContaAzul !== venda.cliente.idContaAzul) {
                        toast.current.show({
                            severity: "warn",
                            summary: "Aviso",
                            detail: "A venda importada pertence a um cliente diferente do cliente da ordem de serviço"
                        });

                        hideProcessing();
                        return;
                    }

                    if (tipoTelhado){
                        ordem.tipoTelhado = tipoTelhado;
                    }

                    ordem.vendas.push(venda);

                    ordem.valor = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.valor || 0), 0);
                    ordem.custo = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.custo || 0), 0);
                    ordem.desconto = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.desconto || 0), 0);

                    ordem.valorTotal = ordem.valor - ordem.desconto;

                    setOrdem({ ...ordem });
                    pendenteSalvar = true;

                }

                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Venda do Conta Azul importada com sucesso"
                });
                setDisplayDialogContaAzul(false);
            }else{

                if (ordem.vendas.length > 0) {
                    toast.current.show({
                        severity: "warn",
                        summary: "Aviso",
                        detail: "Já existe venda na ordem de serviço"
                    });
                    hideProcessing();
                    return;
                }

                showProcessing();
                // Lógica para importar a venda do Conta Azul para a ordem de serviço
                // Por exemplo, você pode chamar uma função do serviço que realiza a importação
                const response = await ordemService.getPessoaContaAzul(documento);

                if (response.status === 200) {
                    ordem.cliente = response.data

                    setOrdem({ ...ordem });

                    pendenteSalvar = true;
                }

                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Cliente do importado com sucesso"
                });
                setDisplayDialogContaAzul(false);
            }
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao importar venda do Conta Azul"
            });
        }

        hideProcessing();
    };

   const anexarDocumento = async () => {

        if (!ordem?.id) {
            toast.current.show({
                severity: "warn",
                summary: "Aviso",
                detail: "É necessário salvar a ordem de serviço antes de anexar documentos"
            });
            return;
        }

        try {
            // Verificar se há arquivos selecionados
            if (!anexoForm.arquivos || anexoForm.arquivos.length === 0) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Selecione pelo menos um arquivo"
                });
                return;
            }

            if (!anexoForm.tipo) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Selecione o tipo de documento"
                });
                return;
            }

            if (anexoForm.tipo === "OUTRO" && !anexoForm.tipoOutro) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Informe o tipo de documento"
                });
                return;
            }

            showProcessing();

            // Processar múltiplos arquivos
            const anexosAdicionados = [];
            let enviouBoletoART = false;

            for (const arquivo of anexoForm.arquivos) {
                const anexo = {
                    nomeArquivo: arquivo.nomeArquivo,
                    observacao: anexoForm.observacao,
                    tipo: anexoForm.tipo,
                    base64: arquivo.base64,
                    idCliente: anexoForm.idCliente,
                    tipoOutro: anexoForm.tipo === "OUTRO" ? anexoForm.tipoOutro : null,
                    status: anexoForm.status,
                    notificarCliente: anexoForm.notificarCliente || false,
                    inParecerAcesso: anexoForm.inParecerAcesso || false
                };

                const response = await ordemService.anexarDocumento(ordem.id, anexo);

                if (anexoForm.tipo === "BOLETO ART" && !enviouBoletoART) {
                    const responseOrdem = await ordemService.solicitarPagamentoART(ordem.id);
                    setOrdem(responseOrdem.data);
                    enviouBoletoART = true;
                } else {
                    anexosAdicionados.push(response.data);
                }
            }

            if (enviouBoletoART) {
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: `${anexoForm.arquivos.length} arquivo(s) anexado(s) e solicitação de pagamento ART realizada com sucesso`
                });
            } else {
                setOrdem({ ...ordem, anexos: [...ordem.anexos, ...anexosAdicionados] });
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: `${anexoForm.arquivos.length} arquivo(s) anexado(s) com sucesso`
                });
            }

            setDisplayAnexarDocumentoDialog(false);
            setAnexoForm({
                nomeArquivo: "",
                observacao: "",
                base64: null,
                arquivos: []
            });
            
            // Recarregar a ordem para atualizar a lista de anexos
            carregarOrdem(ordem.id);
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao anexar documento(s)"
            });
        } finally {
            hideProcessing();
        }
    };

    const handleFileChange = (event) => {
        const files = event.target.files;
        
        if (!files || files.length === 0) {
            setAnexoForm({
                nomeArquivo: "",
                observacao: anexoForm.observacao,
                base64: null,
                arquivos: []
            });
            return;
        }

        // Processar múltiplos arquivos
        const filesArray = Array.from(files);
        const processedFiles = [];
        let filesProcessed = 0;

        filesArray.forEach((file, index) => {
            const reader = new FileReader();
            reader.onload = (e) => {
                const base64String = e.target?.result?.toString().split(',')[1];
                processedFiles[index] = {
                    nomeArquivo: file.name,
                    base64: base64String
                };
                filesProcessed++;

                // Quando todos os arquivos foram processados
                if (filesProcessed === filesArray.length) {
                    setAnexoForm(prev => ({
                        ...prev,
                        nomeArquivo: filesArray.map(f => f.name).join(", "),
                        arquivos: processedFiles
                    }));
                }
            };
            reader.readAsDataURL(file);
        });
    };

    const deleteAnexo = async (anexoId) => {
        try {

            showProcessing();

            await ordemService.deleteAnexo(anexoId);

            toast.current.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Documento deletado com sucesso"
            });

            // Recarregar a ordem para atualizar a lista de anexos
            carregarOrdem(ordem.id);

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao deletar documento"
            });
        } finally {
            hideProcessing();
        }
    }

    const cancelaAgenda = async (agendaId) => {
        if (!window.confirm("Tem certeza que deseja cancelar este agendamento?")) {
            return;
        }

        try {
            showProcessing();

            const response = await ordemService.cancelarAgenda(agendaId);

            if (response.status === 200) {
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Agendamento cancelado com sucesso"
                });
                // Recarregar a ordem para atualizar a lista de agendamentos
                carregarOrdem(ordem.id);
                setAgenda(null);
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao cancelar agendamento"
            });
        } finally {
            hideProcessing();
        }
    }

    const searchEquepesAtivas = async () => {
        try {

            showProcessing();

            const response = await equipeService.getAllAtivas();

            if (response.status === 200) {
                setEquipes(response.data);
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao buscar equipes ativas"
            });
        } finally {
            hideProcessing();
        }
    }

    const showAgendaEquipe = async (equipe) => {
        try{
            showProcessing();

            const response = await agendaService.getByEquipe(equipe.id);

            if (response.status === 200) {  
                setAgendamentos(response.data);
                setDisplayDialogAgendaEquipe(true);
            }

            
        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao exibir agenda da equipe"
            });
        } finally {
            hideProcessing();
        }
    }

    const addAgenda = async () => {
        try{
            showProcessing();

            if (!agenda.dataCompromisso) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Informe a data do compromisso"
                });
                return;
            }

            if (!agenda.equipe) {
                toast.current.show({
                    severity: "warn",
                    summary: "Aviso",
                    detail: "Informe a equipe"
                });
                return;
            }


            const response = await ordemService.saveAgendamento(ordem.id, agenda);

            if (response.status === 200) {
                carregarOrdem(ordem.id);
                setAgenda(null);
                toast.current.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Agendamento realizado com sucesso"
            });
            }

        }catch (error) {

            if (error.response && error.response.data) {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: error.response.data
                });
            } else {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao adicionar agendamento"
                });
            }
        } finally {
            hideProcessing();
        }
    }

    const toDateString = (dateString) => {
        

        if (dateString){
            const [year, month, day] = dateString.split("-");
            return new Date(year, month - 1, day).toLocaleDateString("pt-BR");
        }
        
    }

    const excluirVenda = (venda) => {
        if (window.confirm(`Tem certeza que deseja excluir a venda #${venda.numero} da ordem de serviço?`)) {
            ordem.vendas = ordem.vendas.filter(v => v.numero !== venda.numero);
            
            if (ordem.vendas.length === 0) {
                ordem.cliente = null;
            }

            setOrdem({ ...ordem });
            pendenteSalvar = true;
                
        }
    }

    const getValorOrdem = () => {

        try{
            var valorTotal = ordem.valor;
     
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
            }).format(valorTotal);
        }catch(e){
            return "R$ 0,00";
        }
        
        
    }

    const getDescontoTotalOrdem = () => {

        try{
            var descontoTotal = ordem.desconto;
     
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
            }).format(descontoTotal);
        }catch(e){
            return "R$ 0,00";
        }
        
        
    }

    const getValorTotalOrdem = () => {

        try{

            var valorTotal = ordem.valorTotal;
     
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
            }).format(valorTotal);
        }catch(e){
            return "R$ 0,00";
        }
        
        
    }


    const atualizarVenda = async (venda) => {
        if (window.confirm(`Tem certeza que deseja atualizar a venda #${venda.numero}?`)) {

            try {
            
                await showProcessing();
                
                const response = await ordemService.getVendaContaAzul(venda.numero);

                if (response.status === 200) {

                    var vendaAtualizada = response.data;

                    vendaAtualizada['fotovoltaico'] = venda.fotovoltaico;
                    vendaAtualizada['tipo'] = venda.tipo;

                    var index = ordem.vendas.findIndex(v => v.numero === venda.numero);

                    ordem.vendas[index] = vendaAtualizada;

                    ordem.valor = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.valor || 0), 0);
                    ordem.custo = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.custo || 0), 0);
                    ordem.desconto = ordem.vendas.filter(v => v.status !== "CANCELADA").reduce((total, venda) => total + (venda.desconto || 0), 0);
                    
                    ordem.valorTotal = ordem.valor - ordem.desconto;

                    setOrdem({ ...ordem });
                    
                    pendenteSalvar = true;

                    await saveOrdem();

                }

                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Venda do Conta Azul importada com sucesso"
                });
                
            } catch (error) {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao atualizar venda"
                });
            } finally {
                hideProcessing();
            }
        }
    }

    const getCustoTotalOrdem = () => {
        try{
            var custoTotal = ordem.custo
     
            return new Intl.NumberFormat("pt-BR", {
                style: "currency",
                currency: "BRL"
            }).format(custoTotal);
        }catch(e){
            return "R$ 0,00";
        }
        
    }

    const tiposDocumentoCliente = () => {

        if (ordem?.cliente?.tipoPessoa === "Jurídica") {
            return ["CONTRATO SOCIAL", "FATURA DE ENERGIA", "DISJUNTOR", "PROCURAÇÃO"];
        }else{
            return ["CNH", "IDENTIDADE", "FATURA DE ENERGIA", "DISJUNTOR", "PROCURAÇÃO"];
        }

    }
    
    const tiposDocumentoParecer =  [
        "BOLETO ART", 
        "PARECER DE ACESSO", 
        "MEMORIAL DESCRITIVO", 
        "FORMULARIO DE SOLICITAÇÃO DE ACESSO", 
        "DIAGRAMA UNIFILAR",
        "ANOTAÇÃO DE RESPONSABILIDADE TÉCNICA",
        "CERTIFICADO DE CONFORMIDADE DOS EQUIPAMENTOS PELO INMETRO",
        "PLANTA DE SITUAÇÃO",
        "LISTA DE COMPENSAÇÃO DE CRÉDITOS",
        "DOCUMENTO DE IDENTIFICAÇÃO DO TITULAR",
        "FORMULÁRIO DE ALTERAÇÃO DE CARGA"
    ];

    const tiposDocumentoJson={
        "CNH": {label: "CNH"},
        "IDENTIDADE": {label: "Identidade"},
        "CONTRATO SOCIAL": {label: "Contrato Social"},
        "FATURA DE ENERGIA": {label: "Fatura de Energia"},
        "DISJUNTOR": {label: "Disjuntor"},
        "PROCURAÇÃO": {label: "Procuração"},
        "OUTRO": {label: "Outro"},
    }

    const buildMenu = () => {

        var menu = [];

        if (ordem?.status === "EM CADASTRO" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"])) {
            menu.push({
                label: "Salvar",
                className: "button-save",
                icon: "pi pi-save",
                command: () => saveOrdem()
            });
        }

        if (((ordem?.status === "EM CADASTRO" && hasAuthority("VENDEDOR")) || hasAuthority("ADMINISTRADOR")) && ordem?.status !== "FINALIZADA") {
            menu.push({
                label: "Deletar",
                className: "button-cancel",
                icon: "pi pi-trash",
                command: () => setDisplayDeleteDialog(true)
            });
        }

        var acoes = [];

        if (ordem?.status === "EM CADASTRO" && ordem?.id && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"])) {
            acoes.push({
                label: "Financeiro",
                items: [{
                    label: "Solicitar Análise Financeira",
                    icon: "pi pi-dollar",
                    command: () => solicitarAnaliseFinanceira()
                }]
            });

            if (ordem?.vendas?.length === 0 && ordem?.cliente?.id) {
                acoes.push({
                    label: "Agendamento",
                    items: [{
                        label: "Enviar para Agendamento s/ análise financeira",
                        icon: "pi pi-download",
                        command: () => solicitarAgendamento()
                    }]
                });
            }
        
        }

        if (ordem?.status === "ANALISE FINANCEIRA" && hasAnyAuthority(["ADMINISTRADOR", "FINANCEIRO", "VENDEDOR"])) {
            acoes.push({
                label: "Financeiro",
                items: [{
                    label: "Confirmar Pagamento",
                    icon: "pi pi-check",
                    command: () => confirmarPagamento()
                }]
            });
        }

        if (ordem?.status === "PARECER DE ACESSO" && ordem?.vendas?.filter(v => v.fotovoltaico && v.status !== "CANCELADA").length > 0 && hasAnyAuthority(["ADMINISTRADOR", "PARECER_DE_ACESSO"])) {
            acoes.push({
                label: "Parecer de Acesso",
                items: [{
                    label: "Confirmar aprovação do parecer de acesso",
                    icon: "pi pi-check",
                    command: () => confirmarFinalizacaoParecerAcesso()
                },{
                    label: "Cancelar venda fotovoltaica por rejeição do parecer de acesso",
                    icon: "pi pi-times",
                    command: () => cancelarVendaFotovoltaica()
                }]
            });

        }

        if (ordem?.status === "ORÇAMENTO" && hasAnyAuthority(["ADMINISTRADOR", "ORCAMENTISTA"])) {
            acoes.push({
                label: "ORÇAMENTO",
                items: [{
                    label: "Finalizar Orçamento",
                    icon: "pi pi-check",
                    command: () => finalizarOrcamentoSemPagamento()
                },
                {
                    label: "Solicitar Pagamento",
                    icon: "pi pi-dollar",
                    command: () => finalizarOrcamento()
                }]
            });

        }

        if (ordem?.status === "AGUARDANDO PAGAMENTO" && hasAnyAuthority(["ADMINISTRADOR", "FINANCEIRO"])) {
            acoes.push({
                label: "Financeiro",
                items: [{
                    label: "Confirmar Pagamento",
                    icon: "pi pi-check",
                    command: () => confirmarPagamentoFotovoltaico()
                }]
            });
        }

        if ((ordem?.status === "AGENDADO" || ordem?.status === "REABERTA") && hasAnyAuthority(["ADMINISTRADOR", "AUXILIAR_ADMINISTRATIVO"])) {
            acoes.push({
                label: "Administrativo",
                items: [{
                    label: "Finalizar Ordem de Serviço",
                    icon: "pi pi-check",
                    command: () => finalizarOrdemServico()
                }]
            });
        }

        if (ordem?.status === "PÓS-VENDA" && hasAnyAuthority(["ADMINISTRADOR", "POS_VENDA"])) {
            acoes.push({
                label: "Pós-venda",
                items: [{
                    label: "Finalizar Ordem de Serviço",
                    icon: "pi pi-check",
                    command: () => setPosVenda({ evento: "FINALIZAR" })
                },{
                    label: "Reabrir Ordem de Serviço",
                    icon: "pi pi-refresh",
                    command: () => setPosVenda({ evento: "REABRIR" })
                }]
            });
        }

        if (ordem?.status == "PARECER DE ACESSO" && hasAnyAuthority(["ADMINISTRADOR", "PARECER_DE_ACESSO"])) {
            acoes.push({
                label: "Revisão",
                items: [{
                    label: "Solicitar revisão de documentos",
                    icon: "pi pi-check",
                    command: () => solicitarDocumentoShow()
                }]
            });
        }

        if (ordem?.status == "REVISÃO DE DOCUMENTOS" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"])) {
            acoes.push({
                label: "Revisão",
                items: [{
                    label: "Confirmar revisão de documentos",
                    icon: "pi pi-check",
                    command: () => confirmarRevisaoDocumentos()
                }]
            });
        }

        if (statusOrdemOptions[ordem?.status]?.index >= 2 && statusOrdemOptions[ordem?.status]?.index < 6  && ordem?.vendas?.filter(v => v.fotovoltaico && v.status !== "CANCELADA").length > 0 && hasAnyAuthority(["ADMINISTRADOR", "PARECER_DE_ACESSO"])) {
            acoes.push({
                label: "Parecer de Acesso",
                items: [{
                    label: "Notificar aprovação do parecer de acesso ao cliente",
                    icon: "pi pi-whatsapp",
                    command: () => notificarClienteParecerAcesso()
                }]
            });

        }

        if (ordem?.status === "AGUARDANDO PAGAMENTO ART" && hasAnyAuthority(["FINANCEIRO", "ADMINISTRADOR"])) {
            acoes.push({
                label: "Financeiro",
                items: [{
                    label: "Confirmar pagamento ART",
                    icon: "pi pi-whatsapp",
                    command: () => confirmarPagamentoART()
                }]
            });
        }

        if (acoes.length > 0) {
            menu.push({
                label: "Ações",
                icon: "pi pi-cog",
                items: acoes
            });
        }

        return menu;


    }

    const solicitarDocumentoShow = () => {
        setSolicitarDocumentoDialog(true);
        setSolicitarDocumentoForm({
            observacao: ""
        });
    }

    const solicitarDocumento = async () => {

        if (!window.confirm("Tem certeza que deseja solicitar a revisão de documentos para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.solicitarRevisaoDocumentos(ordem.id, solicitarDocumentoForm);

            if (response.status === 200) {
                setOrdem(response.data);
                setSolicitarDocumentoDialog(false);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Solicitação de revisão de documentos enviada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao solicitar revisão de documentos"
                });
        } finally {
            hideProcessing();
        }
        
    }

    const confirmarPagamentoART = async () => {

        if (!window.confirm("Tem certeza que deseja confirmar o pagamento ART para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.confirmarPagamentoART(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Pagamento ART confirmado com sucesso"
                });
            }

        } catch (error) {

            if (error.response && error.response.data) {
                toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: error.response.data
                });
            } else {
                toast.current.show({
                        severity: "error",
                        summary: "Erro",
                        detail: "Erro ao confirmar pagamento ART"
                });
            }
        } finally {
            hideProcessing();
        }
        
    }

    const confirmarRevisaoDocumentos = async () => {

        if (!window.confirm("Tem certeza que deseja confirmar a revisão de documentos para esta ordem de serviço?")) {
            return;
        }

        try {

            showProcessing();

            const response = await ordemService.confirmarRevisaoDocumentos(ordem.id);

            if (response.status === 200) {
                setOrdem(response.data);
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Revisão de documentos confirmada com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                    severity: "error",
                    summary: "Erro",
                    detail: "Erro ao confirmar revisão de documentos"
                });
        } finally {
            hideProcessing();
        }
        
    }

    const documentosClienteObrigatorios = () => {

        var docs = tiposDocumentoCliente().filter(tipo => !ordem.anexos.some(anexo => anexo.tipo === tipo));

        if (docs.length > 0) {

            docs = docs.map(tipo => tiposDocumentoJson[tipo].label);
            
            return <label style={{color: "red", fontWeight: "bold"}}>{"** Documentos obrigatórios: " + docs.join(", ")}</label>;
            
        }else{
            return "";
        }
    }

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.current.show({
                severity: "success",
                summary: "Sucesso",
                detail: "Texto copiado para a área de transferência"
            });
        }).catch((err) => {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao copiar texto para a área de transferência"
            });
        });
    }

    if (ordem === null) {
        return (
            <div className="page-container">
                <Toast ref={toast} />
                <Card className="page-card">
                    <div className="page-header">
                        <h1>Ordem de Serviço não encontrada</h1>
                        <p>Verifique se o ID da ordem de serviço está correto</p>
                    </div>
                    <Button
                        label="Voltar"
                        icon="pi pi-arrow-left"
                        className="button-confirm"
                        style={{
                            padding: "0.857rem"
                        }}
                        onClick={() => window.location.href = "/ordens"}
                    />
                </Card>
            </div>
        );
    }

    const baixarTodosAnexos = async () => {
        try {
            var anexos = ordem.anexos?.filter(anexo => anexo.idCliente);
            
            for (var anexo of anexos) {
                ordemService.downloadAnexoFile(anexo.id, anexo.nomeArquivo);
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao baixar anexos"
            });
        } finally {
            hideProcessing();
        }
    }

    const tipoVendaDescricao = {
        "AQUECEDOR PISCINA": "Aquecimento solar para piscina",
        "AQUECEDOR RESIDENCIAL": "Aquecimento solar residencial",
        "TROCADOR DE CALOR": "Trocador de calor",
        "SAUNA": "Sauna",
        "PISCINA": "Piscina",
        "FOTOVOLTAICA": "Energia Solar Fotovoltaica",
        "MÃO DE OBRA": "Mão de Obra",
        "MANUTENÇÃO": "Manutenção",
        "OUTROS": "Outros"
    };

    const notificarClienteAgenda = async () => {
        if (!window.confirm("Tem certeza que deseja notificar o cliente sobre este agendamento?")) {
            return;
        }

        try {
            showProcessing();

            const response = await ordemService.notificarClienteAgenda(agenda.id);

            if (response.status === 200) {
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Cliente notificado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao notificar cliente"
            });
        } finally {
            hideProcessing();
        }
    }

    const notificarClienteParecerAcesso = async () => {
        if (!window.confirm("Tem certeza que deseja notificar o cliente sobre a aprovação do parecer de acesso?")) {
            return;
        }

        try {
            showProcessing();

            const response = await ordemService.notificarClienteParecerAcesso(ordem.id);

            if (response.status === 200) {
                toast.current.show({
                    severity: "success",
                    summary: "Sucesso",
                    detail: "Cliente notificado com sucesso"
                });
            }

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao notificar cliente"
            });
        } finally {
            hideProcessing();
        }
    }

    const setEntregue = async (item, value, indexVenda, indexItem) => {

        showProcessing();
        try {
            await ordemService.updateItemEntregue(item.id, value);
            
            const vendas = [...ordem.vendas];
            vendas[indexVenda].itens[indexItem].entregue = value;

            setOrdem({ ...ordem, vendas: vendas });

        } catch (error) {
            toast.current.show({
                severity: "error",
                summary: "Erro",
                detail: "Erro ao atualizar o status de entrega do item"
            });
        } finally {
            hideProcessing();
        }
    }

    const bodyEntregue = (rowData, indexVenda, indexItem) => {
 
        if (statusOrdemOptions[ordem?.status]?.index > 0 && hasAnyAuthority(["ADMINISTRADOR", "AUXILIAR_ADMINISTRATIVO"])){
            return <Checkbox
                key={rowData.id}
                checked={rowData.entregue || false}
                onChange={(e) => {
                    setEntregue(rowData, e.checked, indexVenda, indexItem);
                }}
            />;
        }

        return (
            <div>
                {rowData.entregue ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Sim</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Não</span>
                )}
            </div>
        );
    }

        

    return (
        

        <div className="page-container">
            <Toast ref={toast} />

            <Card className="page-card">
                <div className="page-header">
                    <h1>{id ? `Editar Ordem de Serviço #${ordem?.id}` : "Nova Ordem de Serviço"}</h1>
                    <p>Gerenciar e acompanhar ordens de serviço</p>
                </div>

                <MegaMenu 
                    model={buildMenu()} 
                    orientation="horizontal" 
                    className="page-megamenu" 
                    breakpoint="560px"  

                    end={
                        <Button
                            label="Voltar"
                            icon="pi pi-arrow-left"
                            className="button-confirm"
                            style={{
                                padding: "0.857rem"
                            }}
                            onClick={() => window.location.href = "/ordens"}
                        />
                    }
                />

                
                <Card className="page-card">

                    <div className="page-sub-header">
                        <h2>Dados Gerais Ordem</h2>
                    </div>
                    <p><strong>N#:</strong> {ordem.id}</p>
                    <p><strong>Status:</strong> {ordem.status}</p>

                    <p><strong>Prioridade:</strong> 
                    {ordem?.status === "EM CADASTRO" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"]) ? (
                        <Dropdown 
                            value={ordem.prioridade} 
                            options={prioridadeOptions} 
                            onChange={(e) => {
                                setOrdem({ ...ordem, prioridade: e.value });
                                pendenteSalvar = true;
                            }} 
                            placeholder="Selecione a prioridade" 
                            style={{ marginLeft: "5px" }}
                        />
                    ) : (
                        ordem.prioridade
                    )}</p>

                    {ordem && ordem?.vendas.length > 0 && (
                        <>
                            {ordem.nomeAlteradoPor && (
                                <p><strong>Vendedor:</strong>{ordem.nomeVendedor}</p>
                            )}

                            {ordem && ordem.vendas && ordem.vendas.length > 0 && (
                                <p><strong>Valor:</strong> {getValorOrdem()}</p>
                            )}

                            {ordem && ordem.vendas && ordem.vendas.length > 0 && (
                                <p><strong>Desconto:</strong> {getDescontoTotalOrdem()}</p>
                            )}

                            {ordem && ordem.vendas && ordem.vendas.length > 0 && (
                                <p><strong>Valor Total:</strong> {getValorTotalOrdem()}</p>
                            )}

                            {ordem && ordem.vendas && ordem.vendas.length > 0 && (
                                <p><strong>Custo:</strong> {getCustoTotalOrdem()}</p>
                            )}

                            {ordem && ordem.tipoTelhado && ordem.status !== "EM CADASTRO" && (
                                <p><strong>Tipo de Telhado:</strong> {ordem.tipoTelhado}</p>
                            )}

                            {ordem && ordem.tipoTelhado && ordem.status === "EM CADASTRO" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"]) && (
                                <p>
                                    <strong>Tipo de Telhado:</strong> 
                                    <Dropdown 
                                        value={ordem.tipoTelhado} 
                                        options={
                                        [
                                            {label: "Laje", value: "LAJE"}, 
                                            {label: "Colonial", value: "COLONIAL"},
                                            {label: "Aminanto", value: "AMINATO"},
                                            {label: "Metálico", value: "METÁLICO"},
                                            {label: "Solo", value: "SOLO"}
                                        ]
                                        } 
                                        onChange={(e) => {
                                            setOrdem({ ...ordem, tipoTelhado: e.value });
                                            pendenteSalvar = true;
                                        }} 
                                        placeholder="Selecione o tipo de Telhado" 
                                        style={{ marginLeft: "5px" }}
                                    />
                                </p>
                            )}

                            {ordem.nomeAlteradoPor && (
                                <p><strong>Criado Por:</strong> {ordem.nomeCriadoPor} dia {new Date(ordem.criadoEm).toLocaleString().replace(',', ' às')}</p>
                            )}

                            {ordem.nomeAlteradoPor && (
                                <p><strong>Alterado Por:</strong> {ordem.nomeAlteradoPor} dia {new Date(ordem.alteradoEm).toLocaleString().replace(',', ' às')}</p>
                            )}
                        </>
                    )}
                </Card>
                

                {ordem?.cliente &&(
                    <Card className="page-card" style={{ marginTop: "10px" }}>
                        <div className="page-sub-header">
                            <h2>Dados Cliente</h2>
                        </div>
                        <p><strong>ID:</strong> {ordem.cliente.idContaAzul}</p>
                        <p><strong>Nome:</strong> {ordem.cliente.nome}</p>
                        <p><strong>Documento:</strong> {ordem.cliente.documento}</p>

                        {ordem.cliente.rg && (
                            <p><strong>RG:</strong> {ordem.cliente.rg}</p>
                        )}
                        {ordem.cliente.email && (
                            <p><strong>Email:</strong> {ordem.cliente.email}</p>
                        )}
                        {ordem.cliente.telefoneComercial && (
                            <p><strong>Telefone Comercial:</strong> {ordem.cliente.telefoneComercial}</p>
                        )}
                        {ordem.cliente.telefoneCelular && (
                            <p><strong>Telefone Celular:</strong> {ordem.cliente.telefoneCelular}</p>
                        )}
                        {ordem.cliente.observacao && (
                            <p><strong>Observação:</strong> {ordem.cliente.observacao}</p>
                        )}

                        {ordem.cliente.enderecos && ordem.cliente.enderecos.length > 0 && ordem.cliente.enderecos.map((endereco, index) => (
                                <p key={index}><strong>Endereço {ordem.cliente.enderecos.length > 1 ? index + 1 : ''}:</strong> {`${endereco.logradouro}${endereco.numero ? `, ${endereco.numero}` : ''}, ${endereco.bairro}, ${endereco.cidade}, ${endereco.estado}${endereco.cep ? `, ${endereco.cep}` : ''}`}</p>
                        ))}

                        <div className="page-sub-header">
                            <h2 style={{opacity: .8}}>Documentos Anexados</h2>
                            {(hasAnyAuthority(["ADMINISTRADOR", "AUXILIAR_ADMINISTRATIVO", "VENDEDOR", "PARECER_DE_ACESSO"])) && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && (
                                <p>
                                    <Button 
                                        label="Novo Anexo" 
                                        icon="pi pi-plus" 
                                        style={{backgroundColor: "transparent", border: "none", color: "var(--app-blue-color)"}} onClick={() => {
                                            
                                            if (!ordem?.id) {
                                                toast.current.show({
                                                    severity: "warn",
                                                    summary: "Aviso",
                                                    detail: "É necessário salvar a ordem de serviço antes de anexar documentos"
                                                });
                                                return;
                                            }

                                            setDisplayAnexarDocumentoDialog(true);
                                            setTituloAnexo("Anexar Documento do Cliente");
                                            setTiposDocumento(tiposDocumentoCliente());
                                            setAnexoForm({
                                                nomeArquivo: "",
                                                tipo: null,
                                                observacao: "",
                                                base64: null,
                                                idCliente: ordem.cliente.id
                                            });
        
                                        }}/>
                                </p>
                            )}
                        </div>
                        <div>
                            {ordem?.vendas?.filter(v => v.fotovoltaico && v.status !== "CANCELADA").length > 0 && (
                                documentosClienteObrigatorios()
                            )}
                            
                            <DataTable value={ordem.anexos?.filter(anexo => anexo.idCliente)} className="data-table-no-border-vertical" responsiveLayout="scroll">
                                <Column field="nomeArquivo" header="Nome do Arquivo" />
                                <Column field="tipo" header="Tipo" body={(rowData) => rowData.tipo === "OUTRO" ? rowData.tipoOutro : rowData.tipo} />
                                <Column field="observacao" header="Observação" />
                                <Column body={(rowData) => (
                                    <>
                                        <Button title="Visualizar" icon="pi pi-eye" className="button-confirm" onClick={() => ordemService.visualizarAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        <Button title="Download" icon="pi pi-download" className="button-new" onClick={() => ordemService.downloadAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        {ordem?.status === "EM CADASTRO" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"]) && (
                                            <Button title="Deletar" icon="pi pi-trash" className="button-cancel" onClick={() => {
                                                if (window.confirm(`Tem certeza que deseja deletar o documento ${rowData.nomeArquivo}?`)) {
                                                    deleteAnexo(rowData.id);
                                                }
                                            }}/>
                                        )}
                                    </>
                                )} header={<Button tooltip="Baixar todos" icon="pi pi-download" onClick={() => baixarTodosAnexos()} />} 
                                   style={{width: ordem?.status === "EM CADASTRO" ? "160px" : "120px"}}
                                   alignHeader={"center"}
                                   />
                                
                            </DataTable>
                        </div>
                       

                    </Card>
                )}

                <Card className="page-card" style={{ marginTop: "10px" }}>
                    <div className="page-sub-header">
                        <h2>Vendas Conta Azul</h2>
                        {ordem?.status === "EM CADASTRO" && hasAnyAuthority(["ADMINISTRADOR", "VENDEDOR"]) && (
                            <p>
                                <Button 
                                    label="Importar Venda Conta Azul" 
                                    icon="pi pi-download" 
                                    style={{backgroundColor: "transparent", border: "none", color: "var(--app-blue-color)"}} 
                                    onClick={openVendaContaAzulDialog}/>
                                
                            </p>
                        )}
                    </div>
                
                    <Accordion activeIndex={-1}>
                        {ordem && ordem.vendas && ordem.vendas.length > 0 && (
                            ordem.vendas.map((venda, index) => (
                                <AccordionTab 
                                    key={index} 
                                    header={
                                        <><label style={{textDecoration: venda.status === "CANCELADA" ? "line-through" : "none", color: venda.status === "CANCELADA" ? "red" : "inherit"}}>{`#${venda.numero} ${tipoVendaDescricao[venda.tipo]}`}</label> <label style={{color: venda.status === "CANCELADA" ? "red" : "inherit"}}>{venda.status === "CANCELADA" ? "(Cancelada)" : ""}</label></>
                                    }>

                                    {((hasAuthority("VENDEDOR")) || hasAuthority("ADMINISTRADOR")) && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA"  && (
                                        <Button label="Atualizar Venda" icon="pi pi-refresh" className="button-save" onClick={() => atualizarVenda(venda)} style={{marginBottom: "10px", marginRight: "10px"}}/>
                                    )}
                                    
                                    {((ordem?.status === "EM CADASTRO" && hasAuthority("VENDEDOR")) || hasAuthority("ADMINISTRADOR")) && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA"  && (
                                        <Button label="Excluir Venda" icon="pi pi-trash" className="button-cancel" onClick={() => excluirVenda(venda)} style={{marginBottom: "10px"}}/>
                                    )}

                                    

                                    {ordem.cliente && ordem.cliente.idContaAzul !== venda.cliente.idContaAzul && (
                                        <>
                                        <label style={{color: "red"}}>Atenção: O cliente da venda é diferente do cliente da ordem de serviço</label>
                                        <div className="venda-details">
                                            <p><strong>Cliente:</strong> {venda.cliente.nome}</p>
                                            <p><strong>Data:</strong> {toDateString(venda.dataCompromisos)}</p>
                                            <p><strong>Vendedor:</strong> {venda.nomeVendedor}</p>
                                        </div>
                                        </>
                                    )}
                                    {venda.observacoes && (
                                        <p><strong>Observações:</strong> {venda.observacoes}</p>
                                    )}
                                    <table 
                                        cellPadding={0}
                                        cellSpacing={0}
                                        className="p-datatable p-component p-datatable-responsive-stack p-datatable-hoverable-rows data-table-no-border-vertical" 
                                        style={{width: "100%"}}
                                        >
                                        <thead className="p-datatable-thead">
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Item</th>
                                                <th>Descrição</th>
                                                <th>Qtde</th>
                                                <th>Vlr Unitário</th>
                                                <th>Vlr Total</th>
                                                <th>Custo</th>
                                                <th>Entregue</th>
                                            </tr>
                                        </thead>
                                        <tbody className="p-datatable-tbody">
                                            {venda.itens.map((item, indexItem) => (
                                                <tr key={indexItem}>
                                                    <td>{item.tipo}</td>
                                                    <td>{item.nome}</td>
                                                    <td>{item.descricao}</td>
                                                    <td>{item.quantidade}</td>
                                                    <td>{new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL"
                                                    }).format(item.valor)}</td>
                                                    <td>{new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL"
                                                    }).format(item.valor * item.quantidade)}</td>
                                                    <td>{new Intl.NumberFormat("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL"
                                                    }).format(item.custo)}</td>
                                                    <td>{bodyEntregue(item, index, indexItem)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                        <tfoot className="p-datatable-tfoot">
                                            <tr>
                                                <td colSpan="5" style={{textAlign: "right"}}><strong>Total:</strong></td>
                                                <td>{new Intl.NumberFormat("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL"
                                                }).format(venda.valor)}</td>
                                                <td>{new Intl.NumberFormat("pt-BR", {
                                                    style: "currency",
                                                    currency: "BRL"
                                                }).format(venda.custo)}</td>
                                                <td></td>
                                            </tr>
                                        </tfoot>
                                    </table>

                                </AccordionTab>
                            ))
                        )}
                    </Accordion>
                </Card>

                {ordem && ordem.id && ordem.vendas.filter(venda => venda.fotovoltaico && venda.status !== "CANCELADA").length > 0 &&(
                    <Card className="page-card" style={{ marginTop: "10px" }}>
                        <div className="page-sub-header">
                            <h2>Parecer de Acesso</h2>
                            {statusOrdemOptions[ordem.status].index >= 2 && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && hasAuthority("PARECER_DE_ACESSO") && (
                                <p>
                                    <Button 
                                        label="Anexar Documento" 
                                        icon="pi pi-plus" 
                                        style={{backgroundColor: "transparent", border: "none", color: "var(--app-blue-color)"}} 
                                        onClick={() => {
                                            if (!ordem?.id) {
                                                toast.current.show({
                                                    severity: "warn",
                                                    summary: "Aviso",
                                                    detail: "É necessário salvar a ordem de serviço antes de anexar documentos"
                                                });
                                                return;
                                            }
                                            setDisplayAnexarDocumentoDialog(true); 
                                            setTituloAnexo("Anexar Documentos do Parecer de Acesso");
                                            setTiposDocumento(tiposDocumentoParecer);
                                            setAnexoForm({
                                                nomeArquivo: "",
                                                tipo: "PROVA DE VERIFICAÇÃO",
                                                observacao: "",
                                                inParecerAcesso: true,
                                                base64: null
                                            });
                                        }}/>
                                </p>
                            )}
                        </div>

                        <div>
                            <DataTable value={ordem.anexos?.filter(anexo => anexo.inParecerAcesso)} className="data-table" responsiveLayout="scroll" className="data-table-no-border-vertical" >
                                <Column field="nomeArquivo" header="Nome do Arquivo" />
                                <Column field="tipo" header="Tipo" body={(rowData) => rowData.tipoOutro || rowData.tipo}/>
                                <Column field="observacao" header="Observação" />
                                <Column body={(rowData) => (
                                    <>
                                        <Button title="Visualizar" icon="pi pi-eye" className="button-confirm" onClick={() => ordemService.visualizarAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        <Button title="Download" icon="pi pi-download" className="button-new" onClick={() => ordemService.downloadAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        {ordem?.status === "EM CADASTRO" && (
                                            <Button title="Deletar" icon="pi pi-trash" className="button-cancel" onClick={() => {
                                                if (window.confirm(`Tem certeza que deseja deletar o documento ${rowData.nomeArquivo}?`)) {
                                                    deleteAnexo(rowData.id);
                                                }
                                            }}/>
                                        )}
                                    </>
                                )} style={{width: ordem?.status === "EM CADASTRO" ? "160px" : "120px"}}/>
                                
                            </DataTable>
                        </div>
                        
                    </Card>
                )}

                {ordem && ordem.id &&(
                    <Card className="page-card" style={{ marginTop: "10px" }}>
                        <div className="page-sub-header">
                            <h2>Anexos</h2>
                            {ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && (
                                <p>
                                    <Button 
                                        label="Anexar Documento" 
                                        icon="pi pi-plus" 
                                        style={{backgroundColor: "transparent", border: "none", color: "var(--app-blue-color)"}} 
                                        onClick={() => {
                                            if (!ordem?.id) {
                                                toast.current.show({
                                                    severity: "warn",
                                                    summary: "Aviso",
                                                    detail: "É necessário salvar a ordem de serviço antes de anexar documentos"
                                                });
                                                return;
                                            }
                                            setDisplayAnexarDocumentoDialog(true); 
                                            setTituloAnexo("Anexar Documentos do Parecer de Acesso");
                                            setTiposDocumento(["SOLICITAÇÃO DE PAGAMENTO", "COMPROVANTE DE PAGAMENTO", "VISTORIA TÉCNICA", "LAYOUT SOLAREDGE (ESTUDO DE ÁREA)"]);
                                            setAnexoForm({
                                                nomeArquivo: "",
                                                tipo: null,
                                                observacao: "",
                                                base64: null
                                            });
                                        }}/>
                                </p>
                            )}
                        </div>

                        <div>
                            <DataTable value={ordem.anexos?.filter(anexo => !anexo.inParecerAcesso && !anexo.idCliente)} className="data-table" responsiveLayout="scroll" className="data-table-no-border-vertical" >
                                <Column field="nomeArquivo" header="Nome do Arquivo" />
                                <Column field="tipo" header="Tipo" body={(rowData) => rowData.tipoOutro || rowData.tipo}/>
                                <Column field="observacao" header="Observação" />
                                <Column body={(rowData) => (
                                    <>
                                        <Button title="Visualizar" icon="pi pi-eye" className="button-confirm" onClick={() => ordemService.visualizarAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        <Button title="Download" icon="pi pi-download" className="button-new" onClick={() => ordemService.downloadAnexoFile(rowData.id, rowData.nomeArquivo)} style={{marginRight: "10px"}}/>
                                        {ordem?.status === "EM CADASTRO" && (
                                            <Button title="Deletar" icon="pi pi-trash" className="button-cancel" onClick={() => {
                                                if (window.confirm(`Tem certeza que deseja deletar o documento ${rowData.nomeArquivo}?`)) {
                                                    deleteAnexo(rowData.id);
                                                }
                                            }}/>
                                        )}
                                    </>
                                )} style={{width: ordem?.status === "EM CADASTRO" ? "160px" : "120px"}}/>
                                
                            </DataTable>
                        </div>
                        
                    </Card>
                )}

                {ordem?.status  && statusOrdemOptions[ordem.status].index > 1 && (
                    <Card className="page-card" style={{ marginTop: "10px" }}>
                        <div className="page-sub-header">
                            <h2>Agendamentos</h2>
                            <p>
                                {ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && (
                                    <Button 
                                        label="Novo Agendamento" 
                                        icon="pi pi-plus" 
                                        style={{backgroundColor: "transparent", border: "none", color: "var(--app-blue-color)"}} onClick={() => setAgenda({status: "AGENDADO", tipo: "VISTORIA", equipe: ordem.equipe})}/>
                                )}
                            </p>
                        </div>
                        <div>
                            <DataTable value={ordem.agendamentos} className="data-table" responsiveLayout="scroll" className="data-table-no-border-vertical" >
                                <Column style={{width: "180px"}} field="dataCompromisso" header="Data" body={(rowData) => new Date(rowData.dataCompromisso).toLocaleString("pt-BR").replace(",", " às")} />
                                <Column style={{width: "80px"}} field="tipo" header="Tipo" />
                                <Column style={{width: "100px"}} field="status" header="Status" />
                                <Column field="observacoes" header="Observações" />
                                <Column field="observacoesTecnico" header="Observações Técnico" />
                                <Column body={(rowData) => (
                                    <>
                                        <Button title="Visualizar" icon="pi pi-eye" className="button-confirm" onClick={() => setAgenda(rowData)} style={{marginRight: "10px"}}/>
                                        <Button title="Acesso externo" icon="pi pi-link" className="button-alert" onClick={() => copyToClipboard(window.location.origin + `/agendamento/${rowData.externalAccessUuid}`)} style={{marginRight: "10px"}}/>
                                        
                                    </>
                                )} style={{width: "120px"}}/>
                                
                            </DataTable>
                        </div>
                       

                    </Card>
                )}

                {ordem?.id  && (
                    <Card className="page-card" style={{ marginTop: "10px" }}>
                        <div className="page-sub-header">
                            <h2>Histórico</h2>
                        </div>
                        <div>
                            <DataTable value={ordem.logs} className="data-table" responsiveLayout="scroll" className="data-table-no-border-vertical" >
                                <Column style={{width: "180px", textAlign: "center"}} field="criadoEm" header="Data" body={(rowData) => new Date(rowData.criadoEm).toLocaleString("pt-BR").replace(",", " às")} />
                                <Column style={{width: "200px"}}field="criadoPor.nome" header="Usuário" />
                                <Column field="descricao" header="Descrição" body={(rowData) => <div style={{whiteSpace: "pre-wrap", wordWrap: "break-word"}}>{rowData.descricao}</div>} />
                                <Column field="observacao" header="Observação" body={(rowData) => <div style={{whiteSpace: "pre-wrap", wordWrap: "break-word"}}>{rowData.observacao}</div>} />
                            </DataTable>
                        </div>
                       

                    </Card>
                )}

            </Card>

            {agenda && !displayDialogAgendaEquipe && (
                <Dialog
                    visible={true}
                    style={{ width: "900px", maxWidth: "100%" }}
                    breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                    header={agenda.id ? `Agendamento #${agenda.id}` : "Novo Agendamento"}
                    modal
                    onShow={() => searchEquepesAtivas()}
                    onHide={() => setAgenda(null)}
                    className="agenda-dialog"
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "0" }}>
                        {/* SEÇÃO: INFORMAÇÕES PRINCIPAIS */}
                        <div style={{ paddingBottom: "20px", borderBottom: "1px solid #e0e0e0" }}>
                            <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#333" }}>
                                <i className="pi pi-calendar" style={{ marginRight: "8px" }}></i>
                                Informações do Agendamento
                            </h3>
                            
                            <div style={{ display: "flex", gap: "12px", marginBottom: "12px" }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: "block", marginBottom: "6px", fontSize: "0.85rem", fontWeight: "500", color: "#555" }}>Equipe *</label>
                                    {agenda.id && (
                                        <InputText 
                                            value={agenda.equipe.nome}
                                            readOnly
                                        />
                                    )}
                                    {!agenda.id && (
                                        <Dropdown
                                            value={agenda.equipe || ""}
                                            options={equipes}
                                            onChange={(e) => setAgenda({ ...agenda, equipe: e.value })}
                                            placeholder="Selecione a equipe"
                                            optionLabel="nome"
                                            itemTemplate={(option) => (option.nome + " - " + option.tipoServico)}
                                            style={{ width: "100%" }}
                                            readOnly={agenda.id ? true : false}
                                        />
                                    )}
                                </div>
                                <div>
                                    <label style={{ display: "block", marginBottom: "6px", fontSize: "0.85rem", fontWeight: "500", color: "#555" }}>Tipo *</label>
                                    {agenda.id && (
                                        <InputText 
                                            value={agenda.tipo}
                                            readOnly
                                        />
                                    )}
                                    {!agenda.id && (
                                        <Dropdown
                                            value={agenda.tipo || ""}
                                            options={["INSTALAÇÃO", "VISTORIA"].map((tipo) => ({ label: tipo, value: tipo }))}
                                            onChange={(e) => setAgenda({ ...agenda, tipo: e.value })}
                                            optionLabel="label"
                                            style={{ width: "100%" }}
                                            readOnly={agenda.id ? true : false}
                                        />
                                    )}
                                </div>
                                
                                {!agenda?.id && (
                                    <div>
                                        <label style={{ display: "block", marginBottom: "6px", fontSize: "0.85rem", fontWeight: "500", color: "#555" }}>Notificar Cliente</label>
                                        <Dropdown
                                            style={{ width: "100%" }}
                                            value={agenda.notificarCliente || false}
                                            options={[{label: "Sim", value: true}, {label: "Não", value: false}]}
                                            onChange={(e) => setAgenda({ ...agenda, notificarCliente: e.value })}
                                            readOnly={agenda.id ? true : false}
                                        />
                                    </div>        

                                )}

                                {agenda?.id && (
                                    <div>
                                        <Button className="button-new" label="Notificar Cliente" icon="pi pi-whatsapp" style={{ marginTop: "15px" }} onClick={() => notificarClienteAgenda()}/>
                                    </div>        

                                )}
                                
                            </div>
                            
                            
                            {agenda.equipe && (
                                <Button 
                                    disabled={!agenda.equipe} 
                                    label="Ver Agenda da Equipe" 
                                    icon="pi pi-calendar" 
                                    className="button-confirm" 
                                    style={{ width: "100%", marginTop: "6px", padding: "0.5rem" }}
                                    onClick={() => showAgendaEquipe(agenda.equipe)}
                                />
                            )}
                        </div>

                        {/* SEÇÃO: DATA E HORA */}
                        <div style={{ paddingTop: "20px", paddingBottom: "20px", borderBottom: "1px solid #e0e0e0" }}>
                            <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#333" }}>
                                <i className="pi pi-clock" style={{ marginRight: "8px" }}></i>
                                Data e Hora
                            </h3>
                            
                            <div style={{ display: "flex", gap: "12px" }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: "block", marginBottom: "6px", fontSize: "0.85rem", fontWeight: "500", color: "#555" }}>Data *</label>
                                    {!agenda.id &&
                                        <Calendar 
                                            value={agenda.dataCompromisso ? new Date(agenda.dataCompromisso) : null} 
                                            onChange={(e) => {
                                                if (e.value) {
                                                    const dataAtual = agenda.dataCompromisso ? new Date(agenda.dataCompromisso) : new Date();
                                                    const novaData = new Date(e.value);
                                                    novaData.setHours(dataAtual.getHours(), dataAtual.getMinutes(), 0, 0);
                                                    setAgenda({ ...agenda, dataCompromisso: novaData });
                                                }
                                            }}
                                            showIcon
                                            locale="pt-BR"
                                            dateFormat="dd/mm/yy"
                                            placeholder="Selecione a data"
                                            style={{ width: "100%" }}
                                            touchUI
                                        />
                                    }
                                    {agenda.id &&
                                        <InputText 
                                            value={agenda.dataCompromisso ? new Date(agenda.dataCompromisso).toLocaleDateString("pt-BR") : ""} 
                                            placeholder="Selecione a data"
                                            style={{ width: "100%" }}
                                            readOnly
                                        />
                                    }
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ display: "block", marginBottom: "6px", fontSize: "0.85rem", fontWeight: "500", color: "#555" }}>Hora *</label>
                                    {!agenda.id &&
                                        <Calendar 
                                            value={agenda.dataCompromisso ? new Date(agenda.dataCompromisso) : null} 
                                            onChange={(e) => {
                                                if (e.value) {
                                                    const dataAtual = agenda.dataCompromisso ? new Date(agenda.dataCompromisso) : new Date();
                                                    dataAtual.setHours(e.value.getHours(), e.value.getMinutes(), 0, 0);
                                                    setAgenda({ ...agenda, dataCompromisso: dataAtual });
                                                }
                                            }}
                                            showIcon
                                            locale="pt-BR"
                                            timeOnly
                                            hourFormat="24"
                                            placeholder="Selecione a hora"
                                            style={{ width: "100%" }}
                                            readOnlyInput={agenda.id ? true : false}
                                        />
                                    }
                                    {agenda.id &&
                                        <InputText 
                                            value={agenda.dataCompromisso ? new Date(agenda.dataCompromisso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" }) : ""} 
                                            placeholder="Selecione a hora"
                                            style={{ width: "100%" }}
                                            readOnly
                                        />
                                    }
                                </div>
                            </div>
                        </div>

                        {/* SEÇÃO: OBSERVAÇÕES */}
                        <div style={{ paddingTop: "20px", paddingBottom: "20px", borderBottom: "1px solid #e0e0e0" }}>
                            <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#333" }}>
                                <i className="pi pi-comments" style={{ marginRight: "8px" }}></i>
                                Observações
                            </h3>
                            <InputTextarea 
                                rows={3}
                                value={agenda.observacoes || ""}
                                onChange={(e) => setAgenda({ ...agenda, observacoes: e.target.value })}
                                style={{ width: "100%" }}
                                placeholder="Adicione observações sobre o agendamento"
                                readOnly={agenda.id ? true : false}
                            />
                        </div>

                        {/* SEÇÃO: MONITORAMENTO */}
                        {agenda.id && agenda.monitoramentoAtivo && (
                            <div style={{ paddingTop: "20px", paddingBottom: "20px", borderBottom: "1px solid #e0e0e0", backgroundColor: "#e8f5e9", padding: "15px", borderRadius: "4px", marginTop: "20px" }}>
                                <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#2e7d32" }}>
                                    <i className="pi pi-check-circle" style={{ marginRight: "8px" }}></i>
                                    Monitoramento Ativo
                                </h3>
                                {agenda.usuarioMonitoramento && (
                                    <p style={{ margin: "8px 0", fontSize: "0.9rem" }}>
                                        <strong>👤 Usuário:</strong> <span style={{ fontFamily: "monospace", backgroundColor: "#f5f5f5", padding: "2px 6px", borderRadius: "3px" }}>{agenda.usuarioMonitoramento}</span>
                                    </p>
                                )}
                                {agenda.senhaMonitoramento && (
                                    <p style={{ margin: "8px 0", fontSize: "0.9rem" }}>
                                        <strong>🔐 Senha:</strong> <span style={{ fontFamily: "monospace", backgroundColor: "#f5f5f5", padding: "2px 6px", borderRadius: "3px" }}>{agenda.senhaMonitoramento}</span>
                                    </p>
                                )}
                            </div>
                        )}

                        {/* SEÇÃO: OBSERVAÇÕES TÉCNICO */}
                        {agenda.id && agenda.observacoesTecnico && (
                            <div style={{ paddingTop: "20px", paddingBottom: "20px", borderBottom: "1px solid #e0e0e0", backgroundColor: "#fff3e0", padding: "15px", borderRadius: "4px", marginTop: "20px" }}>
                                <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#e65100" }}>
                                    <i className="pi pi-exclamation-circle" style={{ marginRight: "8px" }}></i>
                                    Observações Técnico
                                </h3>
                                <p style={{ margin: "0", whiteSpace: "pre-wrap", wordWrap: "break-word", fontSize: "0.9rem", lineHeight: "1.5" }}>
                                    {agenda.observacoesTecnico}
                                </p>
                            </div>
                        )}

                        {/* SEÇÃO: ANEXOS */}
                        {agenda.id && agenda.anexos && agenda.anexos.length > 0 && (
                            <div style={{ paddingTop: "20px", paddingBottom: "20px", marginTop: "20px", borderTop: "1px solid #e0e0e0" }}>
                                <h3 style={{ margin: "0 0 15px 0", fontSize: "0.95rem", fontWeight: "600", color: "#333" }}>
                                    <i className="pi pi-paperclip" style={{ marginRight: "8px" }}></i>
                                    Anexos ({agenda.anexos.length})
                                </h3>
                                <DataTable value={agenda.anexos} className="data-table-no-border-vertical" responsiveLayout="scroll" style={{ fontSize: "0.85rem" }}>
                                    <Column field="nomeArquivo" header="Arquivo" />
                                    {agenda.tipo === "INSTALAÇÃO" && (
                                        <Column field="tipo" header="Tipo" body={(rowData) => rowData.tipo === "OUTRO" ? rowData.tipoOutro : rowData.tipo} style={{ width: "120px" }} />
                                    )}
                                    <Column 
                                        body={(rowData) => (
                                            <div style={{ display: "flex", gap: "6px" }}>
                                                <Button 
                                                    title="Visualizar" 
                                                    icon="pi pi-eye" 
                                                    className="button-confirm p-button-sm"
                                                    onClick={() => ordemService.visualizarAnexoFile(rowData.id, rowData.nomeArquivo)} 
                                                    style={{ padding: "0.4rem 0.6rem" }}
                                                />
                                                <Button 
                                                    title="Download" 
                                                    icon="pi pi-download" 
                                                    className="button-new p-button-sm"
                                                    onClick={() => ordemService.downloadAnexoFile(rowData.id, rowData.nomeArquivo)}
                                                    style={{ padding: "0.4rem 0.6rem" }}
                                                />
                                            </div>
                                        )} 
                                        style={{width: "110px"}}
                                        alignHeader={"center"}
                                    />
                                </DataTable>
                            </div>
                        )}
                    </div>

                    {/* RODAPÉ: BOTÕES DE AÇÃO */}
                    <div style={{ display: "flex", gap: "10px", marginTop: "30px", paddingTop: "15px", borderTop: "1px solid #e0e0e0" }}>
                        {!agenda.id && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && (
                            <Button 
                                label="Salvar" 
                                icon="pi pi-save" 
                                className="button-save" 
                                style={{ flex: 1, padding: "0.7rem" }}
                                onClick={addAgenda} 
                            />
                        )}
                        
                        {agenda.id && agenda.status === "AGENDADO" && ordem?.status !== "FINALIZADA" && ordem?.status !== "CANCELADA" && (
                            <Button 
                                label="Cancelar Agendamento" 
                                icon="pi pi-trash" 
                                className="button-cancel" 
                                style={{ flex: 1, padding: "0.7rem" }}
                                onClick={() => {cancelaAgenda(agenda.id);}} 
                            />
                        )}
                    </div>

                </Dialog>
            )}

            {displayDialogAgendaEquipe && (
                <Dialog
                    header="Agenda Equipe"
                    visible={true}
                    style={{ width: "100%", height: "100%" }}
                    breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                    modal
                    onHide={() => setDisplayDialogAgendaEquipe(false)}
                >
                    <Agenda agendamentos={agendamentos} />
                </Dialog>
            )}

            <Dialog
                visible={displayDialogContaAzul}
                style={{ width: "32rem" }}
                breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                header={informarVenda ? "Importar Venda Conta Azul" : "Importar Cliente Conta Azul"}
                modal
                footer={contaAzulDialogFooter}
                onHide={() => setDisplayDialogContaAzul(false)}
            >
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "15px" }}>
                    
                        <Checkbox checked={!informarVenda} onChange={(e) => setInformarVenda(!e.checked)} />
                        <label style={{ display: "block", marginBottom: "5px" }}>Não importar Venda</label>
                    
                </div>
                {informarVenda && (
                    <>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <div>
                                <label style={{ display: "block", marginBottom: "5px" }}>Numero da Venda *</label>
                                <InputText 
                                    placeholder="00000000"
                                    value={numeroVendaContaAzul || ""}
                                    onChange={(e) => setNumeroVendaContaAzul(e.target.value )}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "15px" }}>
                            <div>
                                <label style={{ display: "block", marginBottom: "5px" }}>Tipo *</label>
                                <Dropdown
                                    options={
                                        [
                                            {label: "Aquecimento solar para piscina", value: "AQUECEDOR PISCINA"}, 
                                            {label: "Aquecimento solar residencial", value: "AQUECEDOR RESIDENCIAL"}, 
                                            {label: "Trocador de calor", value: "TROCADOR DE CALOR"},
                                            {label: "Sauna", value: "SAUNA"},
                                            {label: "Piscina", value: "PISCINA"},
                                            {label: "Energia Solar Fotovoltaica", value: "FOTOVOLTAICA"},
                                            {label: "Mão de obra", value: "MÃO DE OBRA"},
                                            {label: "Manutenção", value: "MANUTENÇÃO"},
                                            {label: "Outros", value: "OUTROS"}
                                        ]
                                            
                                        }
                                    value={tipoVenda}
                                    onChange={(e) => {setTipoVenda(e.value); setFotovoltaico(e.value == "FOTOVOLTAICA")}}
                                    style={{ width: "100%" }}
                                />
                            </div>
                            {((ordem?.vendas?.filter(venda => venda.tipo === "FOTOVOLTAICA").length > 0 && tipoVenda && tipoVenda !== "FOTOVOLTAICA") ||
                            (ordem?.vendas?.filter(venda => venda.tipo !== "FOTOVOLTAICA").length > 0 && tipoVenda && tipoVenda === "FOTOVOLTAICA")) && (
                                <div>
                                    <label style={{ display: "block", marginBottom: "5px", color: "red" }}>Atenção: Não é possivel inserir vendas do tipo Energia Solar Fotovoltaica com outras vendas.</label>
                                </div>
                            )}

                        </div>
                        {tipoVenda === "FOTOVOLTAICA" && !ordem.tipoTelhado && (
                            <div style={{ display: "flex", flexDirection: "column", gap: "15px", marginTop: "15px" }}>
                                <div>
                                    <label style={{ display: "block", marginBottom: "5px" }}>Tipo de Telhado</label>
                                    <Dropdown
                                        options={
                                            [
                                                {label: "Laje", value: "LAJE"}, 
                                                {label: "Colonial", value: "COLONIAL"},
                                                {label: "Aminanto", value: "AMINATO"},
                                                {label: "Metálico", value: "METÁLICO"},
                                                {label: "Solo", value: "SOLO"}
                                            ]
                                            }
                                        value={tipoTelhado}
                                        showClear
                                        onChange={(e) => {setTipoTelhado(e.value)}}
                                        style={{ width: "100%" }}
                                    />
                                </div>
                            </div>
                        )}
                    </>
                )}

                {!informarVenda && (
                    <>
                        <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                            <div>
                                <label style={{ display: "block", marginBottom: "5px" }}>Documento Cliente (CPF/CNPJ) *</label>
                                <InputText 
                                    value={documento || ""}
                                    onChange={(e) => setDocumento(e.target.value )}
                                    style={{ width: "100%" }}
                                />
                            </div>
                        </div>
                    </>
                )}
                
            </Dialog>

            <Dialog
                visible={displayDeleteDialog}
                style={{ width: "32rem" }}
                breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                header="Confirmar"
                modal
                footer={deleteDialogFooter}
                onHide={() => setDisplayDeleteDialog(false)}
            >
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
                    <span>Tem certeza que deseja deletar a ordem de serviço <b>{selectedItem?.titulo}</b>?</span>
                </div>
            </Dialog>

            <Dialog
                visible={displayAnexarDocumentoDialog}
                style={{ width: "32rem" }}
                breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                header={tituloAnexo}
                modal
                onHide={() => setDisplayAnexarDocumentoDialog(false)}
            >
                <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Selecione o arquivo *</label>
                        <input 
                            type="file" 
                            ref={fileInputRef}
                            onChange={handleFileChange}
                            multiple={true}
                            style={{ width: "100%" }}
                        />
                        {anexoForm.nomeArquivo && (
                            <p style={{ marginTop: "5px", fontSize: "0.85rem", color: "#666" }}>
                                Arquivo selecionado: {anexoForm.nomeArquivo}
                            </p>
                        )}
                    </div>
                    {tiposDocumento.length > 1 && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Tipo</label>
                            <Dropdown
                                style={{ width: "100%" }}
                                value={anexoForm.tipo || ""}
                                filter
                                options={[...tiposDocumento, "OUTRO"]}
                                onChange={(e) => setAnexoForm({ ...anexoForm, tipo: e.value })}
                            />
                        </div>
                    )}
                    {anexoForm.tipo === "SOLICITAÇÃO DE PAGAMENTO" && ( 
                        <label style={{ display: "block", marginBottom: "5px", color: "red" }}>Atenção: Este documento será enviado para o financeiro</label>
                    )}
                    {anexoForm.tipo === "OUTRO" && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Especifique o tipo</label>
                            <InputText 
                                value={anexoForm.tipoOutro || ""}
                                onChange={(e) => setAnexoForm({ ...anexoForm, tipoOutro: e.target.value })}
                                style={{ width: "100%" }}
                            />
                        </div>
                    )}
                    {anexoForm.tipo === "PARECER DE ACESSO" && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Status</label>
                            <Dropdown
                                style={{ width: "100%" }}
                                value={anexoForm.status || ""}
                                options={["APROVADO", "REPROVADO"]}
                                onChange={(e) => setAnexoForm({ ...anexoForm, status: e.value })}
                            />
                        </div>
                    )}

                    {anexoForm.tipo === "PARECER DE ACESSO" && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Fast Track</label>
                            <Dropdown
                                style={{ width: "100%" }}
                                value={anexoForm.fastTrack == null ? false : anexoForm.fastTrack}
                                options={[{label: "Sim", value: true}, {label: "Não", value: false}]}
                                onChange={(e) => setAnexoForm({ ...anexoForm, fastTrack: e.value })}
                            />
                        </div>
                    )}

                    {anexoForm.tipo === "PARECER DE ACESSO" && anexoForm.status == "APROVADO" && (
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Notificar Cliente</label>
                            <Dropdown
                                style={{ width: "100%" }}
                                value={anexoForm.notificarCliente || false}
                                options={[{label: "Sim", value: true}, {label: "Não", value: false}]}
                                onChange={(e) => setAnexoForm({ ...anexoForm, notificarCliente: e.value })}
                            />
                        </div>
                    )}
                    
                    <div>
                        <label style={{ display: "block", marginBottom: "5px" }}>Observação</label>
                        <InputTextarea 
                            rows={3}
                            value={anexoForm.observacao || ""}
                            onChange={(e) => setAnexoForm({ ...anexoForm, observacao: e.target.value })}
                            style={{ width: "100%" }}
                        />
                    </div>
                </div>
                <Button label="Anexar" icon="pi pi-upload" className="button-save" style={{ marginTop: "10px" }} onClick={() => {
                    anexarDocumento();
                }} />
            </Dialog>

            {posVenda && (
                <Dialog
                    visible={true}
                    style={{ width: "32rem" }}
                    breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                    header={posVenda.evento == "REABRIR" ? "Reabrir Ordem de Serviço" : "Finalizar Ordem de Serviço"}
                    modal
                    onHide={() => setPosVenda(false)}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Observação</label>
                            <InputTextarea 
                                rows={3}
                                value={posVenda.observacao || ""}
                                onChange={(e) => setPosVenda({ ...posVenda, observacao: e.target.value })}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    {posVenda.evento == "FINALIZAR" && (
                        <Button label="Finalizar" icon="pi pi-check" className="button-save" style={{ marginTop: "10px" }} onClick={() => {finalizarOrdemServico();}} />
                    )}

                    {posVenda.evento == "REABRIR" && (
                        <Button label="Reabrir" icon="pi pi-refresh" className="button-cancel" style={{ marginTop: "10px" }} onClick={() => {reabrirOrdemServico();}} />
                    )}
                </Dialog>

            )}

            {solicitarDocumentoDialog && (
                <Dialog
                    visible={true}
                    style={{ width: "32rem" }}
                    breakpoints={{ "960px": "75vw", "640px": "90vw" }}
                    header={"Solicitação de documento"}
                    modal
                    onHide={() => setSolicitarDocumentoDialog(false)}
                >
                    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                        <div>
                            <label style={{ display: "block", marginBottom: "5px" }}>Observação</label>
                            <InputTextarea 
                                rows={3}
                                value={solicitarDocumentoForm.observacao || ""}
                                onChange={(e) => setSolicitarDocumentoForm({ ...solicitarDocumentoForm, observacao: e.target.value })}
                                style={{ width: "100%" }}
                            />
                        </div>
                    </div>
                    <Button label="Solicitar" icon="pi pi-check" className="button-save" style={{ marginTop: "10px" }} onClick={() => {solicitarDocumento();}} />
                </Dialog>

            )}
        </div>
    );
}
